import * as React from 'react';

import {Button} from 'shells/button/button';

export class TableErrorView extends React.Component {
    render() {
        return (
            <div className='ui-entity-list__error-state'>
                <h1 className='ui-entity-list__error-state__title'>We ran into a snag</h1>
                <p className='ui-entity-list__error-state__message'>
                    Your filters, columns, sorting, and selections will be saved.
                </p>
                <Button variant='primary' size='big' onClick={this.handleClick}>
                    Please refresh to continue
                </Button>
                <p className='ui-entity-list__error-state__links'>
                    If this continues to happen,{' '}
                    <a href='https://www.nutshell.com/support'>contact support</a>
                </p>
            </div>
        );
    }

    handleClick = () => {
        location.reload();
    };
}
